import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {dashboardStudyViewerStateDefaults, DashboardStudyViewerStateModel} from './dashboard-study-viewer.model';
import {
  dashboardStudyViewerStateUniqueIdentifier,
  FocusDashboardViewRegion,
  InitDashboardStudyViewer,
  StartDashboardViewerPapaya,
} from './dashboard-study-viewer.actions';
import {DashboardStudyViewerMode} from '../../symbols';
import {DashboardViewRegionBodySegment} from "../../../dashboard-view-regions/types/dashboard-view-regions.types";

@State<DashboardStudyViewerStateModel>({
  name: dashboardStudyViewerStateUniqueIdentifier,
  defaults: dashboardStudyViewerStateDefaults,
})
@Injectable()
export class DashboardStudyViewerState {
  constructor() {}

  @Selector()
  static papayaController(state: DashboardStudyViewerStateModel): DashboardStudyViewerStateModel['papayaController'] {
    return state.papayaController;
  }

  @Action(InitDashboardStudyViewer)
  initDashboardStudyViewer(ctx: StateContext<DashboardStudyViewerStateModel>): void {
  }

  @Action(FocusDashboardViewRegion)
  focusDashboardViewRegion(ctx: StateContext<DashboardStudyViewerStateModel>, {viewRegion}: FocusDashboardViewRegion): void {
    const isPapayaRendered = ctx.getState().isPapayaRendered;

    if (!isPapayaRendered) {
      ctx.dispatch(new StartDashboardViewerPapaya(viewRegion));
      return;
    }
  }

  @Action(StartDashboardViewerPapaya)
  startDashboardViewerPapaya(ctx: StateContext<DashboardStudyViewerStateModel>, {viewRegion}: StartDashboardViewerPapaya): void {
    const activeBodySegment = viewRegion.body_segment;
    const initialViewerMode = defineInitialViewMode(activeBodySegment);

    ctx.patchState({
      isPapayaRendered: true,
      currentStudyViewerMode: initialViewerMode,
    });

  }
}

/**
 * Function to define the initial view mode based on the active body segment.
 * @param activeBodySegment - The active body segment of the view region.
 */
export const defineInitialViewMode = (activeBodySegment: DashboardViewRegionBodySegment): DashboardStudyViewerMode => {
  // Set the viewer mode based on the active body segment:
  switch (activeBodySegment) {
    // For the full body, use Surface mode (as showing profile won't make sense).
    case DashboardViewRegionBodySegment.FullBody:
      return DashboardStudyViewerMode.Surface;

    // For the brain, use SurfaceWithProfile mode.
    case DashboardViewRegionBodySegment.Brain:
      return DashboardStudyViewerMode.SurfaceWithProfile;

    // For some reason the body segment is missing, throw an error.
    default:
      throw new Error('Invalid body segment provided');
  }
};
